import SubTitleUtils from "./SubTitleUtils";
import TimeUtils from "./TimeUtils";
new String("a").valueOf();
export default class StringUtils {
  
  /**
   * 字串相同 true
   * @param {*} targetString
   * @returns
   */
  static checkStringNotDifferent(aString, bString) {
    return (aString  === bString );
  }

  /** 檢察是不是時間字串 */
  static checkIsEffectiveTimeString(targetString) {
    if (targetString.includes(":") && targetString.includes(".")) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 檢查是否只有八位數字
   * */
  static ckeckOnlyEightNumber(targetString) {
    if (targetString === undefined) {
      return "00:00:00.00";
    }

    //console.log(`ckeckOnlyEightNumber ${targetString}`)

    if (targetString === "00:00:00.00") {
      return "00:00:00.00";
    }
    if (targetString === "") {
      return "00:00:00.00";
    }
    if (targetString === null || targetString === "null") {
      return "00:00:00.00";
    }

    const n = `${targetString}`.includes(":");

    if (n === true) {
      let secounsArray1 = targetString.split(":");

      if (secounsArray1.length === 3) {
        return targetString;
      }
    } else {
      const output = `${targetString}`.split("");

      return (
        output[0] +
        output[1] +
        ":" +
        output[2] +
        output[3] +
        ":" +
        output[4] +
        output[5] +
        "." +
        output[6] +
        output[7]
      );
    }

    return "00:00:00.00";
  }

  /** 補零 */
  static checkTimeString(targetString) {
    const videoFps = TimeUtils.getFPS();

    // 00:00:00.16
    if (
      targetString === "00:00:00.00" ||
      targetString === "00:00:00.0" ||
      targetString === "00:00:00."
    ) {
      return "00:00:00.00";
    }

    if (targetString === "") {
      return "";
    }
    if (targetString === null || targetString === "null") {
      return "";
    }

    if (targetString === "") {
      return "";
    }
    // if(targetString.includes('NaN')){
    //     return ''
    // }

    let timeString = StringUtils.ckeckOnlyEightNumber(targetString);
    // console.log(`checkTimeString ${timeString}`);

    let secounsArray1 = timeString.split(":");
    let hour = secounsArray1[0];
    let min = secounsArray1[1];

    //分為秒跟frame
    let secounsOnj2 = secounsArray1[2];
    let secounsFrameArray = secounsOnj2.split(".");

    let secound = secounsFrameArray[0];
    let frame = secounsFrameArray[1];

    let h_string;
    if (parseFloat(hour) < 10) {
      h_string = `0${parseFloat(hour)}`;
    } else {
      h_string = parseFloat(hour);
    }

    let m_string;
    if (parseFloat(min) < 10) {
      m_string = `0${parseFloat(min)}`;
    } else {
      m_string = parseFloat(min);
    }

    let s_string;
    if (parseFloat(secound) < 10) {
      s_string = `0${parseFloat(secound)}`;
    } else {
      s_string = parseFloat(secound);
    }

    let f_string;
    if (frame === "NaN" || frame === "undefined") {
      f_string = "00";
    } else if (parseInt(frame, 10) < 10) {
      f_string = `0${parseInt(frame, 10)}`;
    } else {
      f_string = frame;
    }

    //進位 -----------------------------------------
    if (parseInt(f_string, 10) >= videoFps) {
      var act = parseFloat(f_string) % videoFps;

      const newF = act.toString().padStart(2, "0");

      const moveSecond = Math.trunc(parseFloat(f_string) / videoFps);

      f_string = newF;

      s_string = `${parseFloat(s_string) + moveSecond}`;
    }
    if (parseFloat(s_string) >= 60) {
      s_string = (s_string - 60).toString().padStart(2, "0");
      m_string = `${parseFloat(m_string) + 1}`;
    }
    if (parseFloat(m_string) >= 60) {
      m_string = (m_string - 60).toString().padStart(2, "0");
      h_string = `${parseFloat(h_string) + 1}`;
    }
    //進位 -----------------------------------------

    return `${h_string}:${m_string}:${s_string}.${f_string}`;
  }


  /** 補零 */
  static TimeCodeAddZero(targetString) {
    const videoFps = TimeUtils.getFPS();

    // 00:00:00.16
    if (
      targetString === "00:00:00.00" ||
      targetString === "00:00:00.0" ||
      targetString === "00:00:00."
    ) {
      return "00:00:00.00";
    }

    if (targetString === "") {
      return "";
    }
    if (targetString === null || targetString === "null") {
      return "";
    }

    if (targetString === "") {
      return "";
    }
    // if(targetString.includes('NaN')){
    //     return ''
    // }

    let timeString = StringUtils.ckeckOnlyEightNumber(targetString);
    // console.log(`checkTimeString ${timeString}`);

    let secounsArray1 = timeString.split(":");
    let hour = secounsArray1[0];
    let min = secounsArray1[1];

    //分為秒跟frame
    let secounsOnj2 = secounsArray1[2];
    let secounsFrameArray = secounsOnj2.split(".");

    let secound = secounsFrameArray[0];
    let frame = secounsFrameArray[1];

    let h_string;
    if (parseFloat(hour) < 10) {
      h_string = `0${parseFloat(hour)}`;
    } else {
      h_string = parseFloat(hour);
    }

    let m_string;
    if (parseFloat(min) < 10) {
      m_string = `0${parseFloat(min)}`;
    } else {
      m_string = parseFloat(min);
    }

    let s_string;
    if (parseFloat(secound) < 10) {
      s_string = `0${parseFloat(secound)}`;
    } else {
      s_string = parseFloat(secound);
    }

    let f_string;
    if (frame === "NaN" || frame === "undefined") {
      f_string = "00";
    } else if (parseInt(frame, 10) < 10) {
      f_string = `0${parseInt(frame, 10)}`;
    } else {
      f_string = frame;
    }

    //進位 -----------------------------------------
    if (parseInt(f_string, 10) >= videoFps) {
      var act = parseFloat(f_string) % videoFps;

      const newF = act.toString().padStart(2, "0");

      const moveSecond = Math.trunc(parseFloat(f_string) / videoFps);

      f_string = newF;

      s_string = `${parseFloat(s_string) + moveSecond}`;
    }
    if (parseFloat(s_string) >= 60) {
      s_string = (s_string - 60).toString().padStart(2, "0");
      m_string = `${parseFloat(m_string) + 1}`;
    }
    if (parseFloat(m_string) >= 60) {
      m_string = (m_string - 60).toString().padStart(2, "0");
      h_string = `${parseFloat(h_string) + 1}`;
    }
    //進位 -----------------------------------------

    return `${h_string}:${m_string}:${s_string}.${f_string}`;
  }

  /**  移除第一個字 */
  static removeFirstWord(uncheckString) {
    let wordsArray = uncheckString.split(" ");

    wordsArray.shift();

    let newString = wordsArray.join(" ");
    return newString;
  }

  /**  移除最後一個字 */
  static removeLastWord(uncheckString) {
    var wordsArray = uncheckString.split(" ");

    wordsArray.pop();

    let newString = wordsArray.join(" ");
    return newString;
  }

  /**  取自串的最後文字 */
  static getLastWord(uncheckString) {
    var wordsArray = uncheckString.split(" ");

    let lastIndex = wordsArray.length - 1;
    return wordsArray[lastIndex];
  }

  /**  取自串的第一個文字 */
  static getFirstWord(uncheckString) {
    var wordsArray = uncheckString.split(" ");
    return wordsArray[0];
  }
  /**  檢查字串斷行 */
  static checkNumberOfLineBreaks(uncheckString) {
    var numberOfLineBreaks = (uncheckString.match(/\n/g) || []).length;
    //console.log('Number of breaks: ' + numberOfLineBreaks);

    return numberOfLineBreaks;
  }

  /**  檢查所有html編碼 並且返回新字串 */
  static checkHTMLmark(uncheckString) {
    let newString = uncheckString;

    try {
      if (
        uncheckString === null ||
        uncheckString === "" ||
        uncheckString === undefined
      ) {
        return "";
      }

      newString = newString.replace("&quot;", '"');
      newString = newString.replace("&amp;", "&");
      newString = newString.replace("&lt;", "<");
      newString = newString.replace("&gt;", ">");
      newString = newString.replace("&nbsp;", " ");

      newString = newString.replace("  ", " ");

      newString = newString.replace("<br/>", "\r\n");
      newString = newString.replace("<br />", "\r\n");
      // newString = newString.replace("\\n", "\r\n");
      // newString = newString.replace("\\r\\n", "\r\n");

      //console.log(`checkHTMLmark ${newString}`);

      /**
       * 檢察第一個與最後一個是不是半形空白或是全形空白
       * */
      newString = StringUtils.replaceFullHalfWidth(newString);
    } catch (err) {
      // console.log(`checkHTMLmark ${err}`);
    }

    return newString;
  }

  /**
   * 移除第一個與最後一個是不是半形空白或是全形空白
   * */
  static replaceFullHalfWidth(target) {
    var match = /\r|\n/.exec(target);
    if (match) {
      // console.log('////////');
      // console.log(JSON.stringify(target));

      var target_array = target.split("\n");
      //console.log(target_array);

      let newString = "";

      for (let i = 0; i < target_array.length; i++) {
        const oldTarget = target_array[i];
        if (oldTarget !== "") {
          const newTarget = StringUtils.replaceFullHalfWidth_Active(oldTarget);

          if (i === 0) {
            //如果是第一行 前面不加\n
            newString = newTarget;
          } else {
            newString = `${newString}\n${newTarget}`;
          }
        }
      }
      return newString;
    } else {
      return StringUtils.replaceFullHalfWidth_Active(target);
    }
  }
  /**
   * 執行 去除第一個空白
   * */
  static replaceFullHalfWidth_Active(target) {
    let a = target.split("");
    let b = new Array();
    let j = 0;

    for (let i = 0; i < target.length; i++) {
      if (i === 0 || i === target.length - 1) {
        if (target.charCodeAt(i) != 32 && target.charCodeAt(i) != 12288) {
          b[j] = a[i];
          j++;
        }
      } else {
        b[j] = a[i];
        j++;
      }
    }

    return b.join("");
  }

  /**  取得編輯類別 */
  static getStringChange_key(change) {
    const changeArray = `${change.toString()}`.split(",");
    const key = changeArray[1];

    // console.log(`changeArray key:${key} `);

    return key;
  }

  /**  取得編輯後的RowIndex */
  static getStringChange_rowIndex(change) {
    const changeArray = `${change[0]}`.split(",");
    const rowIndex = changeArray[0];
    return rowIndex;
  }

  /**  檢查編輯後的資料有無 */
  static getStringChange_isChange(change, data, key, beforeChangeData) {
    const changeArray = `${change.toString()}`.split(",");

    // console.log(`getStringChange_isChange ${beforeChangeData}  `);
    // if(changeArray[2] === ''){
    //     return false;
    // }

    if (
      beforeChangeData !== null ||
      beforeChangeData !== undefined ||
      beforeChangeData[key] !== undefined
    ) {
      // console.log(`getStringChange_isChange ${key} ${JSON.stringify(beforeChangeData)}`);

      const beforewantValue = beforeChangeData[key];

      const wantValue = changeArray[3];

      // console.log(`getStringChange_isChange ${wantValue} ${beforewantValue}`);

      if (wantValue === beforewantValue) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  /** 字串位移 <>*/
  static stringMoveUp(way, orgString) {
    let newString = "";

    //<br />
    // console.log(`stringMoveUp ${orgString}`);

    return newString;
  }

  static checkHtml(orgString) {
    // Clean Up whitespace in the element
    // If you don't want to remove whitespace, then you can skip this line
    let newHtml = orgString.replace(/[\n\t ]+/g, " ");

    //RegEX to check HTML
    let checkHtml = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(
      orgString
    );

    //Check it is html or not
    if (checkHtml) {
      console.log("This is an HTML " + orgString + " " + newHtml);
      return true;
    } else {
      console.log("This is a TEXT");
      return false;
    }
  }

  /** 移除字串中的Tag <>*/
  static getStringIgnoreTag(targetString) {
    let str = targetString;

    str = str.replace(/<.*>(.*)<\/.*>/g, "$1");
    // console.log(str);
    return str;
    // str.match(/git/gi);
  }

  /** 確認 全形字 和 半形字的 總長度 <>*/
  static getStringLength(targetString) {
    //checkNumberOfLineBreaks

    if (targetString !== "") {
      var numberOfLineBreaks = (targetString.match(/\n/g) || []).length;

      const stringArray = targetString.split("\n");
      //console.log('Number of breaks: ' + stringArray);

      let lengthArray = [];
      stringArray.map((targetString) => {
        let target = StringUtils.getStringIgnoreTag(targetString);

        let length = 0;
        for (let i = 0; i < target.length; i++) {
          let str = target[i];

          if (str.match(/[\u0000-\u00ff]/g)) {
            //半形
            length += 0.5;
          } else if (str.match(/[\u4e00-\u9fa5]/g)) {
            //中文
            length += 1;
          } else if (str.match(/[\uff00-\uffff]/g)) {
            //全形
            length += 1;
          } else {
            length += 0.5;
          }
        }

        lengthArray.push(length);
      });

      return lengthArray.join("\n");
    } else {
      return 0;
    }
  }

  /** 透過 1:Character 0:Byte 來取得長度*/
  static GetStringByCharacterorByte(fCharacterByteType, targetString) {
    if (fCharacterByteType === parseFloat(0)) {
      let target = StringUtils.getStringIgnoreTag(targetString);

      let length = 0;
      for (let i = 0; i < target.length; i++) {
        let str = target[i];

        if (str.match(/[\u0000-\u00ff]/g)) {
          //半形
          length += 0.5;
        } else if (str.match(/[\u4e00-\u9fa5]/g)) {
          //中文
          length += 1;
        } else if (str.match(/[\uff00-\uffff]/g)) {
          //全形
          length += 1;
        } else {
          length += 0.5;
        }
      }
      return length;
    } else {
      return targetString.length;
    }
  }

  /** 全部都全形*/
  static getStringLength_all(_targetString) {
    // if(_targetString.includes('why I asked you out to eat b') === true){
    //     //console.log('getStringLength_all');
    //     console.log(_targetString);
    // }

    var targetString = SubTitleUtils.setItalicStyle(_targetString,false); 
    //checkNumberOfLineBreaks
    if (targetString === null) {
      return "";
    }

    if (targetString !== "") {
      var numberOfLineBreaks = (targetString.match(/\n/g) || []).length;

      const stringArray_rn = targetString.split("\r\n");
      const stringArray_n = targetString.split("\n");

      const stringArray =
        stringArray_rn > stringArray_n ? stringArray_rn : stringArray_n;

      //console.log('Number of breaks: ' + stringArray);

      let lengthArray = [];
      stringArray.map((targetString) => {
        let target = StringUtils.getStringIgnoreTag(targetString);

        let length = 0;
        for (let i = 0; i < target.length; i++) {
          let str = target[i];

          if (str.match(/[\u0000-\u00ff]/g)) {
            //半形
            length += 1;
          } else if (str.match(/[\u4e00-\u9fa5]/g)) {
            //中文
            length += 1;
          } else if (str.match(/[\uff00-\uffff]/g)) {
            //全形
            length += 1;
          } else {
            length += 1;
          }
        }

        lengthArray.push(length);
      });

      return lengthArray.join("\n");
    } else {
      return "";
    }
  }

  /** 壓縮資料*/
  static ZipUploadFile(jsonsArray) {
    let dataTotalLoop = [];
    jsonsArray.map((data) => {
      dataTotalLoop.push([
        data["In"],
        data["InTimecode"],
        data["start"],
        data["Duration"],
        data["Out"],
        data["OutTimecode"],
        data["end"],
        data["ShotChange"],
        data["Memo"],
        data["Source"],
        data["SubtitleCaption"],
        data["Length"],
        data["Position"],
        data["ShotChangeSecond"],
        data["ShotChangeArray"],
        data["ShotChangeTitle"],
        data["isIgnoreShotchange"],
        data["isInShotChangeActive"],
        data["isOutShotChangeActive"],
      ]);
    });

    return dataTotalLoop;
  }

  /** 重新攤開資料*/
  static UnZipUploadFile(dataArray) {
    if (dataArray.length > 0) {
      const firstObj = dataArray[0];

      if (Array.isArray(firstObj) === true) {
        let finalArray = [];
        dataArray.map((data) => {
          finalArray.push({
            In: data[0],
            InTimecode: data[1],
            start: data[2],
            Duration: data[3],
            Out: data[4],
            OutTimecode: data[5],
            end: data[6],
            ShotChange: data[7],
            Memo: data[8],
            Source: data[9],
            SubtitleCaption: data[10],
            Length: data[11],
            Position: data[12],
            ShotChangeSecond: data[13],
            ShotChangeArray: data[14],
            ShotChangeTitle: data[15],
            isIgnoreShotchange: data[16],
            isInShotChangeActive: data[17],
            isOutShotChangeActive: data[18],
          });
        });

        return finalArray;
      } else {
        return dataArray;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helper/StringUtils.js